<template>
    <div class="about-content">
        <!-- 头部导航公共组件 -->
        <Header :iseNavigat="isChildeNavigat" :isScroll="isScroll" :isMobile="isMobile"></Header>
        
        <!--  -->
        <div :class="['about-content-main', isMobile ? 'isIpadContentBox' : '']" :style="{transform: `scale(${scaleRatio})` }" ref="contentHeight">
            <!-- <div class="about-content-model">
                <div class="about-box-model" @click="handleAboutPreview(1)"><img src="../assets/images/about_modle_1.jpeg" /></div>
                <div class="about-box-text"><span>Short Intro</span> <strong>简版</strong></div>
            </div> -->
            <!-- :style="{ transform: IslargeScreen ? `scale(${ScreenRatio})` : `scale(1)`}" -->
            <div class="content-box">
                <div class="about-content-model about-content-model-one">
                    <div :class="['about-box-model',IslargeScreen ? 'about-box-model-full' : '']" @click="handleAboutPreview(-1)"><img src="../assets/images/about_modle_1.jpg" /></div>
                    <div class="about-box-text"><span>Intro</span> <strong>简介</strong></div>
                </div>
                <div class="about-content-model">
                    <div :class="['about-box-model',IslargeScreen ? 'about-box-model-full' : '']" @click="handleAboutVideoPreview" style="background: #000;"><img src="../assets/images/about_modle_2.jpg" /></div>
                    <div class="about-box-text"><span>Video</span><strong>视频</strong></div>

                    <!-- <div :class="['passwordInpt passwordInptwhite', isSpanceVideoEnter ? 'passwordInptSpance' : '']" v-if="this.videoList[0].uflag == 2">
                        <el-input size="small" type="password" v-model="videoPassword" :placeholder="placeholderText" maxlength="4" @input="handleVideoPasswordInpt"></el-input>
                    </div> -->
                </div>
            </div>
            <!-- <div style="width: 100%;display: flex;align-items: center;justify-content: center;">
                 <el-scrollbar class="scrollbar-model" style="padding-bottom: 35px;"> -->
                    <!-- :style="{ IslargeScreen ? transform: `scale(${scaleRatio})` : ''}" -->
                    <!-- ScreenRatio -->
                     <!-- :style="{ transform: IslargeScreen ? `scale(${ScreenRatio})` : `scale(1)`}" -->
                    <ul :class="['content-Introduct-list', IslargeScreen ? 'content-Introduct-list-full': '']" ref="IntroductHeight">
                        <li v-for="(item, index) in introducNavigat" :key="index" @click="handleAboutPreview(item.etype,item.uflag)">
                            <img :src="item.fileurl"/>
                            <!-- <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && item.etype != 2 && item.ishow">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="spanceIndex == index ? placeholderText : 'Decode 解码'" @input="handlePasswordInpt($event,index,item.pwdstr,item.etype)"></el-input>
                                
                            </div> -->
                        </li>

                        
                        <!-- <li @click="handleAboutPreview(3)">
                            <h1>Public Architecture</h1>
                            <h2>公共建筑</h2>
                        </li>
                        <li @click="handleAboutPreview(4)">
                            <h1>Hotel & Real Estate</h1>
                            <h2>酒店与地产</h2>
                        </li>
                        <li @click="handleAboutPreview(5)">
                        <h1>Urban Renewal</h1>
                        <h2>城市更新</h2> 
                        </li>
                        <li @click="handleAboutPreview(6)">
                        <h1>Supporting Design</h1>
                        <h2>配套设计</h2> 
                        </li> -->
                    </ul>
                 <!-- </el-scrollbar>
            </div> -->
            
           
            
        </div>

        <!-- ================= 项目区：继续向下浏览自动带出项目列表 ================= -->
        <div class="about-project-section">
            <!-- 哨兵：进入视口即加载下方项目内容；未触发前只占位，不请求数据 -->
            <div class="project-section-loading" v-if="!showProjectList" ref="projectSentinel">
                <span>Projects</span>
                <p>Loading 项目内容加载中…</p>
            </div>
            
            <ProjectListSection v-if="showProjectList" />
            
            
            <Footer v-if="showProjectList"></Footer>
        </div>

        <div :class="['mask-layer-model', activeTrantPop ? 'activeTrantPop' : '']">
            <div style="position: absolute;z-index: 999;right: 13px;top: 3px;cursor: pointer;" >
                <img src="../assets/images/close-white.png" @click="handellayerPopModelClose" />
            </div>
            <div :class="['mask-postion-mask',activeTrantPop ? 'activeTrantPop' : '']">
                <!-- ,'padding-top': submenuTop+'px' -->
                <ul class="submenu-introduct-model" :style="{transform: `scale(${scaleRatio})`}">
                
                    <li v-for="(item, index) in submenuListInfo" :key="index" @click="handleAboutPreview(item.etype,item.uflag)">
                        <img :src="item.fileurl" />
                        <!-- <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && item.ishow">
                            <el-input size="small" type="password" v-model="item.password" :placeholder="spanceIndex == index ? placeholderText : 'Decode 解码'" @input="handlePasswordInpt($event,index,item.pwdstr,item.etype)"></el-input>
                        </div> -->
                    </li>
                    <!-- <li>
                        <img src="../assets/images/about/high_2.png" />
                    </li>
                    <li>
                        <img src="../assets/images/about/high_3.png" />
                    </li> -->
                </ul>
            </div>
            
        </div>

        <div :class="['about-pop-model', isPopActive ? 'activePop' : '']">
            <div style="position: absolute;z-index: 999;right: 13px;top: 3px;cursor: pointer;" >
                <img src="../assets/images/close-white.png" @click="handelPopModelClose" />
            </div>
            <el-scrollbar class="scrollbar-model" style="height: 98%;" v-if="imagesList.length > 0">
                <div class="about-detail-main">
                    <el-row :gutter="10">
                        <el-col :lg="{span:'4-8'}" :md="6" :sm="12" :xs="24" v-for="(item, index) in imagesList" :key="index" >
                            <div style="padding-bottom: 5px;cursor: pointer;" :key="index" @click="handleImagePreview(index)">
                                <img :src="item" style=" width: 100%;height: 100%;object-fit: contain;" @contextmenu.prevent>
                            </div>
                        </el-col>

                        <el-col :lg="{span:'4-8'}" :md="6" :sm="12" :xs="24" v-if="isLogin">
                            <div style="padding-bottom: 5px;cursor: pointer; position: relative;" @click="handleDownloadFile">
                                <!-- <div :class="['passwordInpt', password != '' ? 'passwordInptSpance' : '']" v-if="Ispassword && isPC">
                                    <el-input size="small" type="password" v-model="password" :placeholder="placeholderText"></el-input>
                                </div>
                                <div :class="['passwordInpt', password != '' ? 'passwordInptMobileSpance' : '']" v-if="Ispassword && isMobile">
                                    <el-input size="small" type="password" v-model="password" :placeholder="placeholderText"></el-input>
                                    
                                </div> -->
                                <img src="../assets/images/about/download.jpg" style=" width: 100%;height: 100%;object-fit: contain;" @contextmenu.prevent>
                            </div>
                        </el-col>
                        <!-- <el-col :lg="{span:'4-8'}" :md="8" :sm="12" :xs="24" v-if="itemIndex == 1">
                            <div style="padding-bottom: 5px;cursor: pointer;">
                                <a href="../../static/ABOUT CTG-简介-网站简版.pdf" download="CTG-简介-网站简版.pdf"><img src="../assets/images/dowload_img.jpg" style=" width: 100%;height: 100%;object-fit: contain;" @contextmenu.prevent></a>
                            </div>
                        </el-col> -->
                    </el-row>

                    
                    
                </div>
            </el-scrollbar>

            <div style="height: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;font-size: 18px;" v-else>
                <div>页面建设中</div>
                <div>COMING SOON</div>
            </div>

            
            
        </div>

        <div class="Image-Preview-box" v-if="ImagePreviewModle">
            <div style="position: fixed;z-index: 999;right: 20px;top: 20px;cursor: pointer;" >
                <img src="../assets/images/close-white.png" @click="handelImagePreviewClose" />
            </div>
            <el-carousel :interval="0" arrow="always" :autoplay="false" :loop="false" class="Image-Preview-box" ref="carousel" :initial-index="activeIndexInitial" v-model="activeIndex" @change="handleArrowClick" @touchstart.native="handleTouchStart" @touchmove.native="handleTouchMove" @touchend.native="handleTouchEnd" v-if="isPC">
                <el-carousel-item v-for="(item, index) in imagesList" :key="index">
                    <section class="Image-Preview-box" @click="handelImagesExitFullscreen">
                        <img :src="item" @contextmenu.prevent/>
                    </section>
                </el-carousel-item>
            </el-carousel>
            <!--  -->

            <swiper class="Image-Preview-box" :options="swiperOptions" v-if="isMobile">
                <swiper-slide v-for="(item, index) in imagesList" :key="index">
                    <section @click="handelImagesExitFullscreen" style="height: 100%;">
                        <img :src="item" @contextmenu.prevent/>
                    </section>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
        </div>


        <!-- 视频播放 -->
        <div class="Image-Preview-full-box" v-if="isFullVideo" ref="fullVideoModel">
            <div style="position: fixed;z-index: 999;right: 20px;top: 20px;cursor: pointer;" @click="handelVideoviewClose">
                <img src="../assets/images/close-white.png" />
            </div>
            <!-- ../assets/images/video/video.mp4 -->
            <video controls autoplay :src="videoUrl" controlslist="nodownload nofullscreen"></video>
        </div>

        

        <!-- 尾部导航公共组件 -->
        <!-- <Footer></Footer> -->
        <!-- end -->

    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
// 新增：项目列表区块（向下浏览时带出 ProjectList 内容）
import ProjectListSection from '@/components/ProjectListSection.vue'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

// getSubmenuIntroicotherListInfo
import {getAboutIntroductList,setDownloadFileList,getAboutIntroicList,getSubmenuIntroicotherListInfo} from '@/api/axios-api'
// import Footer from '@/components/Footer.vue'

export default {
    name: 'About',
    components: {
        Header,
        ProjectListSection,
        Swiper,
        SwiperSlide,
        Footer,
        // HelloWorld,
        // loading
    },
    data () {
        return {
            isFullVideo: false,
            ismenu: false,
            ImagePreviewModle: false,
            isScroll: 4,
            videoHeight: 0,
            isNavigat: false,
            isChildeNavigat: true,
            // currentSectionIndex: 0,
            // lastScrollTime: 0, // 上次滚动的毫秒时间戳
            // scrollSpeed: 500, // 滚动速度（毫秒）
            // lastScrollTime: null,
            // lastScrollDirection: 0,
            // screenHeight: 0
            // activeIndex: 0, // 当前激活的图片索引
            imagesList: [],
            // images: [
            //     require('@/assets/images/about/about1.jpeg'),
            //     require('@/assets/images/about/about2.jpeg'),
            //     require('@/assets/images/about/about3.jpeg'),
            //     require('@/assets/images/about/about4.jpeg'),
            //     require('@/assets/images/about/about5.jpeg'),
            //     require('@/assets/images/about/about6.jpeg'),
            //     require('@/assets/images/about/about7.jpeg'),
            //     require('@/assets/images/about/about8.jpeg'),
            //     require('@/assets/images/about/about9.jpeg'),
            //     require('@/assets/images/about/about10.jpeg'),
            //     require('@/assets/images/about/about11.jpeg'),
            //     require('@/assets/images/about/about12.jpeg'),
            //     require('@/assets/images/about/about13.jpeg'),
            //     require('@/assets/images/about/about14.jpeg'),
            //     require('@/assets/images/about/about15.jpeg'),
            //     require('@/assets/images/about/about16.jpeg'),
            //     require('@/assets/images/about/about17.jpeg'),
            //     require('@/assets/images/about/about18.jpeg'),
            //     require('@/assets/images/about/about19.jpeg'),
            //     require('@/assets/images/about/about20.jpeg'),
            //     require('@/assets/images/about/about21.jpeg'),
            //     require('@/assets/images/about/about22.jpeg'),
            //     require('@/assets/images/about/about23.jpeg'),
            //     require('@/assets/images/about/about24.jpeg'),
            //     require('@/assets/images/about/about25.jpeg'),
            //     require('@/assets/images/about/about26.jpeg'),
            //     // require('@/assets/images/about/about27.jpeg'),
            //     // require('@/assets/images/about/about28.jpeg'),
            //     // require('@/assets/images/about/about28.jpeg'),
            //     // require('@/assets/images/about/about29.jpeg'),
            //     // require('@/assets/images/about/about30.jpeg'),
            //     // 更多图片路径
            // ],
            // fullImgas: [
            //     require('@/assets/images/about/full/about_1.jpeg'),
            //     require('@/assets/images/about/full/about_2.jpeg'),
            //     require('@/assets/images/about/full/about_3.jpeg'),
            //     require('@/assets/images/about/full/about_4.jpeg'),
            //     require('@/assets/images/about/full/about_5.jpeg'),
            //     require('@/assets/images/about/full/about_6.jpeg'),
            //     require('@/assets/images/about/full/about_7.jpeg'),
            //     require('@/assets/images/about/full/about_8.jpeg'),
            //     require('@/assets/images/about/full/about_9.jpeg'),
            //     require('@/assets/images/about/full/about_10.jpeg'),
            //     require('@/assets/images/about/full/about_11.jpeg'),
            //     require('@/assets/images/about/full/about_12.jpeg'),
            //     require('@/assets/images/about/full/about_13.jpeg'),
            //     require('@/assets/images/about/full/about_14.jpeg'),
            //     require('@/assets/images/about/full/about_15.jpeg'),
            //     require('@/assets/images/about/full/about_16.jpeg'),
            //     require('@/assets/images/about/full/about_17.jpeg'),
            //     require('@/assets/images/about/full/about_18.jpeg'),
            //     require('@/assets/images/about/full/about_19.jpeg'),
            //     require('@/assets/images/about/full/about_20.jpeg'),
            //     require('@/assets/images/about/full/about_21.jpeg'),
            //     require('@/assets/images/about/full/about_22.jpeg'),
            //     require('@/assets/images/about/full/about_23.jpeg'),
            //     require('@/assets/images/about/full/about_24.jpeg'),
            //     require('@/assets/images/about/full/about_25.jpeg'),
            //     require('@/assets/images/about/full/about_26.jpeg'),
            //     require('@/assets/images/about/full/about_27.jpeg'),
            //     require('@/assets/images/about/full/about_28.jpeg'),
            //     require('@/assets/images/about/full/about_29.jpeg'),
            //     require('@/assets/images/about/full/about_30.jpeg'),
            //     require('@/assets/images/about/full/about_31.jpeg'),
            //     require('@/assets/images/about/full/about_32.jpeg'),
            //     require('@/assets/images/about/full/about_33.jpeg'),
            //     require('@/assets/images/about/full/about_34.jpeg'),
            //     require('@/assets/images/about/full/about_35.jpeg'),
            //     require('@/assets/images/about/full/about_36.jpeg'),
            //     require('@/assets/images/about/full/about_37.jpeg'),
            //     require('@/assets/images/about/full/about_38.jpeg'),
            //     require('@/assets/images/about/full/about_39.jpeg'),
            //     require('@/assets/images/about/full/about_40.jpeg'),
            //     require('@/assets/images/about/full/about_41.jpeg'),
            //     require('@/assets/images/about/full/about_42.jpeg'),
            //     require('@/assets/images/about/full/about_43.jpeg'),
            //     require('@/assets/images/about/full/about_44.jpeg'),
            //     require('@/assets/images/about/full/about_45.jpeg'),
            //     require('@/assets/images/about/full/about_46.jpeg'),
            //     require('@/assets/images/about/full/about_47.jpeg'),
            //     require('@/assets/images/about/full/about_48.jpeg'),
            //     require('@/assets/images/about/full/about_49.jpeg'),
            //     require('@/assets/images/about/full/about_50.jpeg'),
            //     require('@/assets/images/about/full/about_51.jpeg'),
            //     require('@/assets/images/about/full/about_52.jpeg'),
            //     require('@/assets/images/about/full/about_53.jpeg'),
            //     require('@/assets/images/about/full/about_54.jpeg'),
            //     require('@/assets/images/about/full/about_55.jpeg'),
            //     require('@/assets/images/about/full/about_56.jpeg'),
            //     require('@/assets/images/about/full/about_57.jpeg'),
            //     require('@/assets/images/about/full/about_58.jpeg'),
            //     require('@/assets/images/about/full/about_59.jpeg'),
            //     require('@/assets/images/about/full/about_60.jpeg'),
            //     require('@/assets/images/about/full/about_61.jpeg'),
            //     require('@/assets/images/about/full/about_62.jpeg'),
            //     require('@/assets/images/about/full/about_63.jpeg'),
            //     require('@/assets/images/about/full/about_64.jpeg'),
            //     require('@/assets/images/about/full/about_65.jpeg'),
            //     require('@/assets/images/about/full/about_66.jpeg'),
            //     require('@/assets/images/about/full/about_67.jpeg'),
            //     require('@/assets/images/about/full/about_68.jpeg'),
            //     require('@/assets/images/about/full/about_69.jpeg'),
            //     require('@/assets/images/about/full/about_70.jpeg'),
            //     require('@/assets/images/about/full/about_71.jpeg'),
            //     require('@/assets/images/about/full/about_72.jpeg'),
            //     require('@/assets/images/about/full/about_73.jpeg'),
            //     require('@/assets/images/about/full/about_74.jpeg'),
            //     require('@/assets/images/about/full/about_75.jpeg'),
            //     require('@/assets/images/about/full/about_76.jpeg'),
            //     require('@/assets/images/about/full/about_77.jpeg'),
            //     require('@/assets/images/about/full/about_78.jpeg'),
            //     require('@/assets/images/about/full/about_79.jpeg'),
            //     require('@/assets/images/about/full/about_80.jpeg'),
            //     require('@/assets/images/about/full/about_81.jpeg'),
            //     require('@/assets/images/about/full/about_82.jpeg'),
            //     require('@/assets/images/about/full/about_83.jpeg'),
            //     require('@/assets/images/about/full/about_84.jpeg'),
            //     require('@/assets/images/about/full/about_85.jpeg'),
            //     require('@/assets/images/about/full/about_86.jpeg'),
            //     require('@/assets/images/about/full/about_87.jpeg'),
            //     require('@/assets/images/about/full/about_88.jpeg'),
            //     require('@/assets/images/about/full/about_89.jpeg'),
            //     require('@/assets/images/about/full/about_90.jpeg'),
            //     require('@/assets/images/about/full/about_91.jpeg'),
            //     require('@/assets/images/about/full/about_92.jpeg'),
            //     require('@/assets/images/about/full/about_93.jpeg'),
            //     require('@/assets/images/about/full/about_94.jpeg'),
            //     require('@/assets/images/about/full/about_95.jpeg'),
            //     require('@/assets/images/about/full/about_96.jpeg'),
            //     require('@/assets/images/about/full/about_97.jpeg'),
            //     require('@/assets/images/about/full/about_98.jpeg'),
            //     require('@/assets/images/about/full/about_99.jpeg'),
            //     require('@/assets/images/about/full/about_100.jpeg'),
            //     require('@/assets/images/about/full/about_101.jpeg'),
            //     require('@/assets/images/about/full/about_102.jpeg'),
            //     require('@/assets/images/about/full/about_103.jpeg'),
            //     require('@/assets/images/about/full/about_104.jpeg'),
            //     require('@/assets/images/about/full/about_105.jpeg'),
            //     require('@/assets/images/about/full/about_106.jpeg'),
            //     require('@/assets/images/about/full/about_107.jpeg'),
            //     require('@/assets/images/about/full/about_108.jpeg'),
            //     require('@/assets/images/about/full/about_109.jpeg'),
            //     require('@/assets/images/about/full/about_110.jpeg'),
            //     require('@/assets/images/about/full/about_111.jpeg'),
            //     require('@/assets/images/about/full/about_112.jpeg'),
            //     require('@/assets/images/about/full/about_113.jpeg'),
            //     require('@/assets/images/about/full/about_114.jpeg'),
            //     require('@/assets/images/about/full/about_115.jpeg'),
            //     require('@/assets/images/about/full/about_116.jpeg'),
            //     require('@/assets/images/about/full/about_117.jpeg'),
            //     require('@/assets/images/about/full/about_118.jpeg'),
            //     require('@/assets/images/about/full/about_119.jpeg'),
            //     require('@/assets/images/about/full/about_120.jpeg'),
            //     require('@/assets/images/about/full/about_121.jpeg'),
            //     require('@/assets/images/about/full/about_122.jpeg'),
            //     require('@/assets/images/about/full/about_123.jpeg'),
            //     require('@/assets/images/about/full/about_124.jpeg'),
            //      require('@/assets/images/about/full/about_125.jpeg'),
            //     require('@/assets/images/about/full/about_126.jpeg'),
            //     require('@/assets/images/about/full/about_127.jpeg'),
            //     require('@/assets/images/about/full/about_128.jpeg'),
            //     require('@/assets/images/about/full/about_129.jpeg'),
            //     require('@/assets/images/about/full/about_130.jpeg'),
            // ],
            // lastScrollTime: 0, // 上次滚动的毫秒时间戳
            // scrollSpeed: 0, // 滚动的速度
            // isRollerSpeed: true,
            // escCount: 0
            activeIndex: 0,
            activeIndexInitial: 0,
            isRollerSpeed: true,
            // imagesList: [],
            escCount: 0,
            isPopActive: false,
            itemIndex: '',
            isPC: false, // 代表pc端
            isMobile: false, // 代表移动端
            swiperOptions: {
                initialSlide: 0, // 设定初始化时slide的索引
                // direction: 'vertical', // Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
            startX: 0,
            currentX: 0,
            touchThreshold: 50, // 设置触发滑动的阈值（像素）
            scaleRatio: 1,
            ScreenRatio: 1,
            IslargeScreen: false, // 分辨率小于1920
            baseWidth: 1920,
            password: '',
            Ispassword: false,
            systemLanguage: '', // 获取系统语言
            etype: '',
            // placeholderText: '',
            placeholderText: 'Decode 解码',
            introducNavigat: [],
            isSpanceEnter: false,
            pwdstr: '',
            spanceIndex: 0,
            videoPassword: '',
            videoList: [],
            isSpanceVideoEnter: false,
            isLogin: false,
            submenuTop: 0,
            // 新增：是否渲染下方项目区（滚动到临界点后置 true）
            showProjectList: false,
            projectObserver: null,
            activeTrantPop: false,
            submenuListInfo: [],
            videoUrl: ''
        }
    },

    created () {
        
        
        // alert(window.innerWidth)
        // alert(window.devicePixelRatio)
         const userAgent = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|Macintosh|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        //  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        //  alert(userAgent)
         if (userAgent) {
            this.isMobile = true
            this.scaleRatio = window.innerWidth / 1600
            // alert(this.scaleRatio)
         } else {
            this.isPC = true
            if (window.innerWidth < 1920) {
                this.scaleRatio = window.innerWidth / this.baseWidth
                this.IslargeScreen = false
            } else if (window.innerWidth > 1920) {

                this.IslargeScreen = true
                this.scaleRatio = window.innerWidth / 2560

            }

            window.onresize = () => {

            if (window.innerWidth < 1920) {
                    this.scaleRatio = window.innerWidth / this.baseWidth
                    this.IslargeScreen = false
                } else if (window.innerWidth > 1920) {
                    this.IslargeScreen = true
                    this.scaleRatio = window.innerWidth / 2560
                
                }
            }
         }

        

        this.getAboutIntroicListFun()

        // 
        
    },
   
    mounted () {

        

        document.body.style.overflow = 'auto'

        window.addEventListener('keydown', this.globalKeyDown)

        // 新增：监听下方项目区哨兵，浏览到该位置时再加载项目内容
        this.initProjectObserver()

        
        
    },
     beforeDestroy() {
        window.removeEventListener('keydown', this.globalKeyDown)

        // 新增：销毁时断开项目区滚动监听
        if (this.projectObserver) {
            this.projectObserver.disconnect()
            this.projectObserver = null
        }
        window.removeEventListener('keyup', this.KeyDownloadUpFlieHandler)
        window.removeEventListener('keyup', this.Seedetails)
        window.removeEventListener('keyup', this.Videoplayback)
        
    },
    methods: {

        // 新增：监听项目区哨兵元素，浏览者向下滚动接近项目区时再渲染并请求项目数据
        // 首屏不产生额外请求，滚动到位后才加载，保证 About 页原有打开速度
        initProjectObserver () {
            // 老浏览器不支持 IntersectionObserver 时直接加载，保证内容可见
            if (typeof IntersectionObserver === 'undefined') {
                this.showProjectList = true
                return
            }
            this.$nextTick(() => {
                const sentinel = this.$refs.projectSentinel
                if (!sentinel) {
                    this.showProjectList = true
                    return
                }
                this.projectObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.showProjectList = true
                            this.projectObserver.disconnect()
                            this.projectObserver = null
                        }
                    })
                }, { rootMargin: '0px 0px 300px 0px', threshold: 0 })
                this.projectObserver.observe(sentinel)
            })
        },

        // 高层建筑、公共建筑、酒店与地产、城市更新、配套设计
        getAboutIntroicListFun () {
            getAboutIntroicList().then(res => {
                if (res.code == 0) {
                    // console.log(res)
                    const newList = []
                    const newVideoList = []
                    for (let i = 0; i < res.map.list.length; i++) {
                        if (res.map.list[i].etype != 7) {
                            const listObj = {}
                            listObj.btype = res.map.list[i].btype
                            listObj.ctime = res.map.list[i].ctime
                            listObj.etype = res.map.list[i].etype
                            listObj.filename = res.map.list[i].filename
                            listObj.fileurl = res.map.list[i].fileurl
                            listObj.introrarid = res.map.list[i].introrarid
                            listObj.pstate = res.map.list[i].pstate
                            listObj.pwdstr = res.map.list[i].pwdstr
                            listObj.uflag = res.map.list[i].uflag
                            // listObj.ishow = false
                            listObj.password = ''

                            newList.push(listObj)
                        } else {
                            const videoObj = {}
                            videoObj.btype = res.map.list[i].btype
                            videoObj.ctime = res.map.list[i].ctime
                            videoObj.introrarid = res.map.list[i].introrarid
                            videoObj.pstate = res.map.list[i].pstate
                            videoObj.pwdstr = res.map.list[i].pwdstr
                            videoObj.uflag = res.map.list[i].uflag

                            newVideoList.push(videoObj)
                        }
                        
                    }
                    this.introducNavigat = newList
                    this.videoList = newVideoList

                    this.$nextTick(() => {
                        // alert(document.body.clientHeight)
                        // - this.$refs.IntroductHeight.clientHeight - 62
                        // alert((this.$refs.IntroductHeight.clientHeight - 130)*this.scaleRatio)
                        this.submenuTop = (this.$refs.contentHeight.clientHeight / 2) + 130 + ((this.$refs.IntroductHeight.clientHeight - 130)*this.scaleRatio) / 2
                        // alert(this.$refs.headerHeight.clientHeight)
                        // this.submenuTop = this.$refs.headerHeight.clientHeight + this.$refs.contentHeight.clientHeight + 130
                        // alert()
                    })
                }
            })
        },

        // 下载文件
        handleDownloadFile () {
            this.getDownloadUpList()
            // this.Ispassword = true
            // window.addEventListener('keyup', this.KeyDownloadUpFlieHandler)
        },

        // KeyDownloadUpFlieHandler(event) {
        //     if (event.key === 'Enter' || event.keyCode === 13) {
        //         // console.log('全局回车键被按下');
        //         this.getDownloadUpList()
        //         // 添加你的逻辑
        //     }
        // },

        getDownloadUpList () {
            // if (this.password == '') {
            //     this.password = ''
            //     this.placeholderText = '密码错误'
            //     return false
            // }
            const parseInfo = {}
            parseInfo.etype = this.etype
            parseInfo.pwdstr = this.password

            setDownloadFileList(parseInfo).then(res => {
                if (res.code == 0) {

                    if (res.map.map == '') {
                        // this.password = ''
                        for (let i = 0; i < this.introducNavigat.length; i++) {
                            this.introducNavigat[i].password = ''
                        }
                        for (let i = 0; i < this.submenuListInfo.length; i++) {
                            this.submenuListInfo[i].password = ''
                        }

                        this.isSpanceEnter = false
                        // this.placeholderText = '密码错误'
                        this.placeholderText = '密码错误'
                    } else {
                        this.password = ''
                        this.Ispassword = false

                        const url = res.map.map.fileurl; // 或者通过 axios 获取的 blob URL
                        // const url = '../sdts.pdf'
                        const link = document.createElement('a');
                        link.href = url;
                        // link.download = url
                        if (this.etype == 1) {
                            link.download = 'Intro 简介'
                        } else if (this.etype == 2) {
                            link.download = 'High-rise Buildings 高层建筑'
                        } else if (this.etype == 3) {
                            link.download = 'Public Architecture 公共建筑'
                        } else if (this.etype == 4) {
                            link.download = 'Hotels & Villas 酒店与地产'
                        } else if (this.etype == 5) {
                            link.download = 'Educational Architecture 教育建筑'
                        } else if (this.etype == 6) {
                            link.download = 'Supporting design 配套设计'
                        }
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link); // 清理
                    }
                }
            })
        },


        handleAboutVideoPreview () {
            // this.FullVideoUrl = mousefileurl
            // alert(this.videoList[0].uflag)
            if (this.videoList[0].uflag == 1) {

                const parseInfo = {}
                parseInfo.etype = 7

                setDownloadFileList(parseInfo).then(res => {
                    if (res.code == 0) {
                        this.videoUrl = res.map.map.fileurl
                        this.isFullVideo = true
                        document.body.style.overflow = 'hidden'
                        this.toggleFullScreen()
                    }
                })
                
            }

            
            
        },

        handleVideoPasswordInpt (event) {
            this.videoPassword = event
            if (this.videoPassword === '') {
                this.isSpanceVideoEnter = false
            } else {
                this.isSpanceVideoEnter = true
            }

            window.addEventListener('keyup', this.Videoplayback) // 按回车键监听输入密码跳转详情页
            // window.addEventListener('keyup', this.Seedetails) // 按回车键监听输入密码跳转详情页
        },

        Videoplayback (event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                if (this.videoPassword == this.videoList[0].pwdstr) {
                    this.isFullVideo = true
                    document.body.style.overflow = 'hidden'
                    this.videoPassword = ''
                    this.placeholderText = 'Decode 解码'
                    this.isSpanceVideoEnter = false
                    this.toggleFullScreen()
                } else {
                    // this.videoList[0].password = ''
                    this.videoPassword = ''
                    // this.isEnter = false
                    this.isSpanceVideoEnter = false
                    this.placeholderText = '密码错误'
                }
            }
        },

        handelVideoviewClose () {
            document.exitFullscreen()
            this.isFullVideo = false
            document.body.style.overflow = 'auto'
        },

        handleAboutPreview (itemIndex) {
            this.imagesList = []

            // alert(itemIndex)
            
            if (itemIndex == -1) {
                this.etype = 1
                const parseInfo = {}
                parseInfo.etype = 1
                getAboutIntroductList(parseInfo).then(res => {
                    if (res.code == 0) {
                        this.isLogin = res.map.ispc
                        this.imagesList = res.map.list
                        // console.log(res)
                        // this.itemIndex = itemIndex
                        this.isPopActive = true
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error',
                            offset: 80,
                            duration: 2000
                        }) 
                    }
                })
            } else {
                if (itemIndex == 2) {
                    
                    getSubmenuIntroicotherListInfo().then(res => {
                        if (res.code == 0) {
                            // console.log(res)
                            this.submenuListInfo = res.map.list
                            this.activeTrantPop = true
                        }
                    })
                } else {
                   
                    // if (uflag == 1) {
                        // 直接访问
                        this.etype = itemIndex

                        // this.getDownloadUpList()
                        // this.etype = itemIndex
                        const parseInfo = {}
                        parseInfo.etype = itemIndex
                        getAboutIntroductList(parseInfo).then(res => {
                            if (res.code == 0) {
                                this.isLogin = res.map.ispc
                                this.imagesList = res.map.list
                                // console.log(res)
                                // this.itemIndex = itemIndex
                                this.isPopActive = true
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: 'error',
                                    offset: 80,
                                    duration: 2000
                                }) 
                            }
                        })
                    // }
                }
                
            }
            
            
            
            // if (itemIndex == 1) {
            //     this.imagesList = this.images
            // } else if (itemIndex == 2) {
            //     this.imagesList = this.fullImgas
            // }
            this.activeIndex = 0
            // this.ImagePreviewModle = true
            // this.toggleFullScreen()
            // this.addMouseWheelListener();
        },

        handellayerPopModelClose () {
            this.activeTrantPop = false
        },

        handlePasswordInpt (event, index,pwdstr,itemIndex) {
            this.password = event
            // console.log(index)

            this.etype = itemIndex

            // console.log(this.password)
            this.spanceIndex = index

            this.pwdstr = pwdstr

            if (this.password === '') {
                this.isSpanceEnter = false
            } else {
                this.isSpanceEnter = true
            }

            window.addEventListener('keyup', this.Seedetails) // 按回车键监听输入密码跳转详情页
        },

        Seedetails(event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                this.getDownloadUpList()
                // if (this.password == this.pwdstr) {
                //     // this.setJumpDetailsFun(this.proid,this.mousefileurl,this.password)
                //     this.introducNavigat[this.spanceIndex].password = ''
                //     this.isSpanceEnter = false
                //     this.placeholderText = 'Decode 解码'

                //     // const parseInfo = {}
                //     // parseInfo.etype = this.etype
                //     // getAboutIntroductList(parseInfo).then(res => {
                //     //     if (res.code == 0) {
                //     //         this.imagesList = res.map.list
                //     //         // console.log(res)
                //     //         // this.itemIndex = itemIndex
                //     //         this.isPopActive = true
                //     //     } else {
                //     //         this.$message({
                //     //             message: res.message,
                //     //             type: 'error',
                //     //             offset: 80,
                //     //             duration: 2000
                //     //         }) 
                //     //     }
                //     // })
                    

                // } else {
                //     // this.password = ''
                //     this.introducNavigat[this.spanceIndex].password = ''
                //     // this.isEnter = false
                //     this.isSpanceEnter = false
                //     this.placeholderText = '密码错误'
                // }
            }
        },

        handelPopModelClose () {
            this.imagesList = []
            this.Ispassword = false
            this.isPopActive = false
        },

        globalKeyDown(event) {
            if (event.key === 'ArrowLeft') {
                // console.log('左键被按下');
                // 处理左键逻辑
                this.prevImageSlide();
            } else if (event.key === 'ArrowRight') {
                // console.log('右键被按下');
                // 处理右键逻辑
                this.nextImageSlide();
                
            } else if (event.key === 'Escape') {
                this.escCount++; // 增加ESC键按下的次数计数
                if (this.escCount >= 2) { // 如果按了两次ESC键，则退出全屏并重置计数器
                    document.exitFullscreen()
                    window.removeEventListener('wheel', this.addMouseWheelListener)
                    this.ImagePreviewModle = false
                    this.escCount = 0; // 重置计数器
                    document.body.style.overflow = 'auto'
                } else { // 如果未达到两次，则不执行任何操作，等待下一次按键事件来增加计数器
                    setTimeout(() => this.escCount = 0, 500); // 延迟重置计数器，以防误操作（用户可能只是想关闭菜单等）
                }
                // 按下esc
                // console.log('121')
                // $Modal.remove()
                
            } else {
                this.escCount = 0
            }
        },

        handleImagePreview (index) {
            // this.ImagePreviewList = this.detailObj.imgs
            this.swiperOptions.initialSlide = index

            this.activeIndex = index
            this.activeIndexInitial = index
            this.ImagePreviewModle = true
            document.body.style.overflow = 'hidden'
            
            this.toggleFullScreen()
            this.addMouseWheelListener()
            
        },

        handelImagePreviewClose () {
           
            this.activeIndex = 0
            this.ImagePreviewModle = false
            document.body.style.overflow = 'auto'
            document.exitFullscreen()
            window.removeEventListener('wheel', this.addMouseWheelListener)
            
            
        },

         handleArrowClick (value) {
            this.activeIndex = value
        },

        handelImagesExitFullscreen () {

            if ((this.activeIndex + 1) == this.imagesList.length) {
                this.activeIndex = 0
                document.exitFullscreen()
                this.ImagePreviewModle = false
                window.removeEventListener('wheel', this.addMouseWheelListener)
                document.body.style.overflow = 'auto'
            }
            
           
        },

        addMouseWheelListener() {
            this.$nextTick(() => {
                const carouselEl = this.$refs.carousel.$el; // 获取 Carousel 元素的引用
                console.log(carouselEl)
                carouselEl.addEventListener('wheel', (event) => {
                
                    if (this.isRollerSpeed) {
                        if (event.deltaY < 0) {
                        // 向前滚动（向上）
                            this.prevImageSlide();
                        } else {
                        // 向后滚动（向下）
                            this.nextImageSlide();
                        
                        }
                    }
                    this.isRollerSpeed = false
                    setTimeout(() => {
                        this.isRollerSpeed = true
                        event.preventDefault()
                    }, 1500)
                })
            
                
            });
        },

        nextImageSlide() {
            
            // console.log(this.detailObj.imgs.length)
            if ((this.activeIndex + 1) < this.imagesList.length) {
                this.activeIndex = (this.activeIndex + 1) % this.imagesList.length
                this.$refs.carousel.next(); // 调用 Carousel 的 next 方法
                // console.log('加'+this.activeIndex)
            }
            
            
        },
        prevImageSlide() {

            if (this.activeIndex > 0) {
                this.activeIndex = (this.activeIndex - 1) % this.imagesList.length
                this.$refs.carousel.prev(); // 调用 Carousel 的 prev 方法
                // console.log('减'+this.activeIndex)
            }
            
        },

        // pc端电脑触屏滑动轮播
        handleTouchStart(event) {
            this.startX = event.touches[0].clientX;
        },
        handleTouchMove(event) {
            this.currentX = event.touches[0].clientX;
        },

        handleTouchEnd() {
            if (Math.abs(this.currentX - this.startX) > this.touchThreshold) {
                if (this.currentX - this.startX > 0) {
                   this.activeIndex = (this.activeIndex - 1) % this.imagesList.length
                // 向左滑动，切换到下一张图片（此处需要调用 Element UI 的方法或通过索引控制）
                 this.$refs.carousel.prev(); // 同上，需要有 ref="carousel" 在 el-carousel 上
                } else {
                 this.activeIndex = (this.activeIndex + 1) % this.imagesList.length
                // 向右滑动，切换到上一张图片（此处需要调用 Element UI 的方法或通过索引控制）
                
                this.$refs.carousel.next(); // 假设你有一个 ref 在 el-carousel 上，例如 ref="carousel"
                }
            }
        },

        toggleFullScreen() {
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen().catch(err => {
                    alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`)
                })
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                }
            }
        },

        
    }
}
</script>

<style scoped lang="scss">
// ================= 新增：About 页下方项目区（继续下滚带出 ProjectList 内容） =================
.about-project-section {
    width: 100%;
    background: #fff;
    padding-bottom: 60px;
}
.about-project-section .project-section-loading {
    width: 100%;
    padding: 60px 0 80px 0;
    text-align: center;
    color: #262626;
}
.about-project-section .project-section-loading span {
    font-family: "ahronbd";
    font-size: 1.5rem;
    font-weight: 500;
    letter-spacing: 2px;
}
.about-project-section .project-section-loading p {
    margin-top: 10px;
    font-family: "SourceHanSans";
    font-size: 1rem;
    color: #999;
}

.about-content {
    width: 100%;
    // 原为 height: 100%（只有一屏高、无法下滚），改为 min-height，让页面可继续向下浏览
    min-height: 100%;
}

.about-content .about-content-main {
    // width: 1755px;
    // 原为 height: calc(100% - 6.875rem)：高度锁死在一屏内会阻断向下滚动，改为 min-height
    min-height: calc(100vh - 6.875rem);
    padding-top: 6.875rem;
    // overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // position: relative;
    // background: red;
}
.about-content .content-box {
    display: flex;
    justify-content: center;
    // background: red;
}
.about-content .about-content-model {
    text-align: center;
    // display: inline-block;
    // background: red;
    // margin-right: 6%;
    position: relative;
}
.about-content .about-content-model:last-child{
    margin-right: 0;
}
.about-content .about-box-model {
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 436px;
    // height: 243px;
    width: 409px;
    height: 231px;
    text-align: center;
    // width: 400px;
    // height: 200px;
    border-radius: 3px;
    cursor: pointer;
    border: 1px solid #565656;
    box-sizing: border-box;
    
}
.about-content .about-box-model-full {
    width: 545px;
    height: 308px;
}
.about-content .about-box-model img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.about-content .about-content-model-one {
    // background: #fff;
    // border: 1px solid #a4a4a4;
    box-sizing: border-box;
    margin-right: 66px;
}
.about-content .about-box-text {
    padding-top: 24px;
}
.about-content .about-box-text span {
    font-size: 20px;
    font-family: "ahronbd";
}
.about-content .about-box-text strong {
    font-size: 20px;
    font-family: "SourceHanSansBOLD";
}

.about-content .Image-Preview-box {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    z-index: 99;
}
// .about-content .about-content-model {
//     overflow-y: hidden;
//     height: 100vh; /* 让容器高度为视口高度 */
// }
.about-content .Image-Preview-box {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    // background: #000;
}
.about-content .Image-Preview-box::v-deep .el-carousel__container {
    height: 100vh;
}
.about-content .Image-Preview-box::v-deep .el-carousel__indicators {
    display: none;
}
.about-content .Image-Preview-box img{
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.about-content .section-model {
  position: relative;
  width: 100%;
  height: auto;
}
.about-content .slide-show-model {
  position: sticky;
  top: -43vh;
  // display: flex;
  background: #fff;
}
.about-content .slide-show-model img {
  width: 100%;
  object-fit: cover;
  vertical-align: middle;
}
.about-content .about-pop-model {
    position: fixed;
    left: 0;
    top: 0;
    width: calc(100% - 10px);
    height: 100%;
    background: #f8f8f8;
    z-index: 99;
    padding: 10px 5px;
    transform: translateY(100%); /* 从元素底部开始 */
    transition: transform 1s ease; /* 定义过渡效果 */
}
.about-content .about-pop-model.activePop {
    transform: translateY(0); /* 从元素底部开始 */
}
.about-content .about-detail-main {
    width: calc(100% - 20px);
    margin: auto;
}
.about-content .scrollbar-model::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
}
.about-content .scrollbar-model::v-deep .el-scrollbar__thumb {
    background-color: rgba(0, 0, 0, .5);
}

.about-content .Image-Preview-full-box {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    z-index: 999;
}
.about-content .Image-Preview-full-box video {
    width: 100%;
    height: 100%;
    // object-fit: cover;
}

.about-content .content-Introduct-list {
    // display: flex;           /* 启用Flexbox布局 */
    // justify-content: center;
    // flex-wrap: wrap;         /* 允许子项换行 */
    // justify-content: space-around; /* 子项之间的空间分布均匀 */
    // list-style-type: none;   /* 移除列表的默认样式 */
    // padding: 0;              /* 移除默认的内边距 */
    // width: calc(100% - 40px);
    // width: 1935px;
    // width: 1560px;
    display: flex;
    justify-content: center;
    padding-top: 130px;
    // position: relative;
    // margin-top: 130px;
}
.about-content .content-Introduct-list li {
    // flex: 1;
    // width: 339px;
    // flex: 1 1 20%;
    // height: 190px;
    width: 277px;
    height: 152px;
    // width: 296px;
    // height: 137px;
    float: left;
    // background: #F2F2F2;
    margin-right: 20px;
    border: 1px solid #7F7F7F;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 10px;
    position: relative;
}
.about-content .content-Introduct-list li img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    border-radius: 10px;
}

.about-content .content-Introduct-list-full li{
    width: 369px;
    height: 205px;
}
.about-content .content-Introduct-list li h1 {
    font-size: 20px;
    font-family: 'ahronbd';
}
.about-content .content-Introduct-list li h2 {
    font-size: 18px;
    font-family: 'SourceHanSansBOLD';
}
.about-content .content-Introduct-list li:last-child{
    margin-right: 0;
}

.about-content .submenu-introduct-model {
    // position: absolute;
    // bottom: 0;
    // transform: translateY(100%)!important;
    // left: 0;
    // z-index: 9999;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    // padding-top: calc(100% - 6.875rem);
}
// .about-content .submenu-introduct-model {
   
// }
.about-content .submenu-introduct-model li {
    width: 466px;
    // height: 28vh;
    // height: 269px;
    float: left;
    margin-right: 70px;
    // border: 1px solid #7F7F7F;
    // box-shadow: 0 4px 8px -1px rgba(0, 0, 0, 0.5);
    // box-shadow: 2px 3px 8px rgba(0, 0, 0, 0.5);
    box-shadow: 1px 5px 8px rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    // border-radius: 10px;
    position: relative;
}
.about-content .submenu-introduct-model li img {
    width: 100%;
    height: 100%;
    -o-object-fit: fill;
    object-fit: fill;
    vertical-align: bottom;
    // border-radius: 10px;
    // margin-left: -1px;
}
// .about-content .submenu-introduct-model li:nth-child(1) img, .about-content .submenu-introduct-model li:nth-child(2) img{
//     margin-left: -1px;
// }
.about-content .submenu-introduct-model li:last-child {
    margin-right: 0;
}

.about-content .mask-layer-model {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99;
    top: 0;
    left: 0;
    bottom: 0;
    // bottom: calc(100% - 6.875rem);
    background: rgba(255, 255, 255, 1);
    // display: none;
    transform: translateY(100%); /* 从元素底部开始 */
    transition: transform 1s ease; /* 定义过渡效果 */

}



.about-content .mask-layer-model.activeTrantPop {
    // display: block;
    transform: translateY(0); /* 从元素底部开始 */
}
.about-content .mask-postion-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 0;
    transform: translateY(100%); /* 从元素底部开始 */
    transition: transform 1s ease; /* 定义过渡效果 */
}
.about-content .mask-postion-mask.activeTrantPop {
    transform: translateY(0); /* 从元素底部开始 */
}


// .header-model {
//     width: 100%;
//     height: 100px;
//     position: fixed;
//     z-index: 99;
//     transition: top 0.5s ease;
// }
// .menu-fold {
//     font-size: 30px;
//     color: #fff;
//     cursor: pointer;
//     display: none;
// }
// .header-bg-model {
//     background: #fff;
//     // border-bottom: 1px solid #E5E6E6;
//     box-sizing: border-box;
//     top: 0;
// }
// .header-model .header-content {
//     width: calc(100% - 66px);
//     margin: auto;
//     // transform: translateX(-50%);
//     height: 100px;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
// }
// .isHeaderShow {
//     top: -100px;
// }
// .header-model .menu-navigat {
//     display: flex;
//     flex-direction: row;
//     margin-top: 35px;
// }
// .header-model .menu-fixed {
//     background: #fff;
//     position: fixed;
//     left: 0;
//     top: 70px;
//     bottom: 0;
//     width: 100%;
// }

// .header-model .menu-navigat .menu-list.menu-fixed {
//     display: flex;
//     transform: translateX(0); /* 从右向左移动 */
//     transition: transform 2s ease; /* 添加过渡效果 */
//     padding: 0 3%;
// }

// .header-model .menu-navigat .menu-fixed .menu-list {
//     display: flex;
//     flex-direction: column;
//     align-items: flex-start;
// }
// .header-model .menu-navigat .menu-fixed .menu-list li{
//     padding: 15px 0;
// }
// .header-model .menu-navigat ul {
//     display: flex;
//     flex-direction: row;
//     align-items: center;
// }
// .header-model .menu-navigat .menu-list.menu-fixed ul {
//     flex-direction: column;
//     align-items: flex-start;
// }
// .header-model .menu-navigat ul.menu-list {
//     display: flex;
//     // transform: translateX(0); /* 从右向左移动 */
// }
// .header-model .menu-navigat li {
//     // float: left;
//     // margin-left: 15px;
//     padding: 0 10px;
    
// }
// .header-model .menu-navigat .menu-list.menu-fixed li {
//     padding: 10px 0;
// }
// .header-model .menu-navigat li a {
//     color: #fff;
//     font-size: 24px;
//     font-weight: 700;
//     font-family: "ahronbd";
// }
// .header-bg-model .menu-navigat li a {
//     color: #545454;
// }
// .header-model .menu-navigat li a:hover {
//     color: #000;
// }
// .icon-close-color {
//     color: #000;
// }

.about-content .Image-Preview-box::v-deep .Image-Preview-box .swiper-button-next {
    background-image: url('../assets/images/button-right.png');
    background-size: 100% 100%;
    width: 20px;
    height: 36px;
}
.about-content .Image-Preview-box::v-deep .Image-Preview-box .swiper-button-next::after {
    display: none;
}

.about-content .Image-Preview-box::v-deep .Image-Preview-box .swiper-button-prev {
    background-image: url('../assets/images/button-left.png');
    background-size: 100% 100%;
    width: 20px;
    height: 36px;
}

.about-content .Image-Preview-box::v-deep .Image-Preview-box .swiper-button-prev::after {
    display: none;
}

.about-content::v-deep .passwordInpt {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 150px;
  margin-left: -75px;
  // top: 65%;
  margin-top: 26px;
  background-color: #000;
  border-radius: 16px;
  
}

.about-content::v-deep .passwordInpt.passwordInptwhite {
    background-color: #fff;
    margin-top: 10px;
}

.about-content::v-deep .passwordInpt.passwordInptwhite .el-input__inner {
    background-color: #fff;
    border: 1px solid #fff;
    color: #000;
}
.about-content::v-deep .passwordInpt .el-input__inner {
  background-color: #000;
  border: 1px solid #000;
  border-radius: 17px;
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-family: "SourceHanSans";
//   letter-spacing: 3px;
}
.about-content::v-deep .passwordInptSpance .el-input__inner{
    letter-spacing: 5px;
    // font-size: 7px;
    font-size: 25px;
    font-family: '微软雅黑';
    height: 32px;
    line-height: 32px;
}
.about-content::v-deep .passwordInptMobileSpance .el-input__inner{
    letter-spacing: 5px;
    font-size: 10px;
    // font-size: 25px;
    // font-family: '微软雅黑';
    height: 32px;
    line-height: 32px;
}



// @media (max-width: 768px) {
//     .header-model .header-content {
//         width: calc(100% - 66px)
//     }
//     .menu-fold {
//         display: block;
//     }
//     .header-model .menu-navigat .menu-list {
//         display: none;
//         transform: translateX(100%); /* 从右向左移动 */
//         transition: transform 2s ease; /* 添加过渡效果 */
//     }
// }

@media only screen and (min-width: 1200px) {
.el-col-lg-4-8 {
    width: 25%;
}
.el-col-lg-offset-4-8 {
    margin-left: 25%;
}
.el-col-lg-pull-4-8 {
    position: relative;
    right: 25%;
}
.el-col-lg-push-4-8 {
    position: relative;
    left: 25%;
}
}
@media only screen and (min-width: 1500px) {
.el-col-lg-4-8 {
    width: 20%;
}
.el-col-lg-offset-4-8 {
    margin-left: 20%;
}
.el-col-lg-pull-4-8 {
    position: relative;
    right: 20%;
}
.el-col-lg-push-4-8 {
    position: relative;
    left: 20%;
}
}

@media only screen and (min-width: 1920px) {
.el-col-xl-4-8 {
    width: 20%;
}
.el-col-xl-offset-4-8 {
    margin-left: 20%;
}
.el-col-xl-pull-4-8 {
    position: relative;
    right: 20%;
}
.el-col-xl-push-4-8 {
    position: relative;
    left: 20%;
}
}


@media only screen and (max-width: 1280px) {
  .about-content .content-Introduct-list {
    padding-top: 82px;
  }
}

// ipad 样式
// .about-content .isIpadContentBox .content-box {
//     height: 800px;
// }
.about-content .isIpadContentBox {
    padding-top: 70px;
}
.about-content .isIpadContentBox .about-box-model {
    // background: red;
    // width: 459px;
    // height: 311px;
}

.about-content .isIpadContentBox .about-box-text span {
    font-size: 2.5rem;
    // color: red;
}
.about-content .isIpadContentBox .about-box-text strong {
    font-size: 2rem;
}
.about-content .isIpadContentBox .content-Introduct-list li {
    // width: 337px;
    // height: 192px;
}

.about-content .isIpadContentBox .content-Introduct-list {
    // margin-top: 250px;
    // margin-top: 8.125rem;
    // padding-top: 8rem;
    padding-top: 140px;
    // background: red;
}
</style>